<div class="helpful-container">
  <mat-tab-group mat-stretch-tabs="false" class="helpful-tabs" dynamicHeight>
    <mat-tab label="Add Helpful">
      <ninety-add-helpful />
    </mat-tab>
    <mat-tab label="Company Export">
      @if (canExportDirectoryCsv$ | ngrxPush) {
        <ninety-export-csv />
      }
    </mat-tab>
    <mat-tab label="Email Suppression List">
      <ninety-email-suppression-list />
    </mat-tab>
    @if (canHardDeleteCompany$ | ngrxPush) {
      <mat-tab label="Hard Delete Company">
        <ninety-hard-delete-company />
      </mat-tab>
    }
  </mat-tab-group>
</div>
